module.exports = __webpack_public_path__ + "static/media/0763eab1-d6ed-4c73-afb0-895f930df099.c15c72e5.woff";